// Ce fichier est genere automatiquement par tools/generate-spritesheet-config.js
// Ne pas modifier manuellement
// Dossier: whisper | Taille: 256x256px | Directions: 5

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const WhisperSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'whisper-attack',
    metadata: {
      frames: {
        'whisper-attack-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-20': {
          frame: {
            x: 5120,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-21': {
          frame: {
            x: 5376,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-22': {
          frame: {
            x: 5632,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-23': {
          frame: {
            x: 5888,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-16': {
          frame: {
            x: 4096,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-17': {
          frame: {
            x: 4352,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-18': {
          frame: {
            x: 4608,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-19': {
          frame: {
            x: 4864,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-20': {
          frame: {
            x: 5120,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-21': {
          frame: {
            x: 5376,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-22': {
          frame: {
            x: 5632,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-bottom-left-23': {
          frame: {
            x: 5888,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-16': {
          frame: {
            x: 4096,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-17': {
          frame: {
            x: 4352,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-18': {
          frame: {
            x: 4608,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-19': {
          frame: {
            x: 4864,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-20': {
          frame: {
            x: 5120,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-21': {
          frame: {
            x: 5376,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-22': {
          frame: {
            x: 5632,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-left-23': {
          frame: {
            x: 5888,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-16': {
          frame: {
            x: 4096,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-17': {
          frame: {
            x: 4352,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-18': {
          frame: {
            x: 4608,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-19': {
          frame: {
            x: 4864,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-20': {
          frame: {
            x: 5120,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-21': {
          frame: {
            x: 5376,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-22': {
          frame: {
            x: 5632,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-left-23': {
          frame: {
            x: 5888,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-16': {
          frame: {
            x: 4096,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-17': {
          frame: {
            x: 4352,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-18': {
          frame: {
            x: 4608,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-19': {
          frame: {
            x: 4864,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-20': {
          frame: {
            x: 5120,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-21': {
          frame: {
            x: 5376,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-22': {
          frame: {
            x: 5632,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-attack-top-23': {
          frame: {
            x: 5888,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/whisper/attack.png',
        size: {
          w: 6144,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'whisper-attack-bottom': [
          'whisper-attack-bottom-0',
          'whisper-attack-bottom-1',
          'whisper-attack-bottom-2',
          'whisper-attack-bottom-3',
          'whisper-attack-bottom-4',
          'whisper-attack-bottom-5',
          'whisper-attack-bottom-6',
          'whisper-attack-bottom-7',
          'whisper-attack-bottom-8',
          'whisper-attack-bottom-9',
          'whisper-attack-bottom-10',
          'whisper-attack-bottom-11',
          'whisper-attack-bottom-12',
          'whisper-attack-bottom-13',
          'whisper-attack-bottom-14',
          'whisper-attack-bottom-15',
          'whisper-attack-bottom-16',
          'whisper-attack-bottom-17',
          'whisper-attack-bottom-18',
          'whisper-attack-bottom-19',
          'whisper-attack-bottom-20',
          'whisper-attack-bottom-21',
          'whisper-attack-bottom-22',
          'whisper-attack-bottom-23',
        ],
        'whisper-attack-bottom-left': [
          'whisper-attack-bottom-left-0',
          'whisper-attack-bottom-left-1',
          'whisper-attack-bottom-left-2',
          'whisper-attack-bottom-left-3',
          'whisper-attack-bottom-left-4',
          'whisper-attack-bottom-left-5',
          'whisper-attack-bottom-left-6',
          'whisper-attack-bottom-left-7',
          'whisper-attack-bottom-left-8',
          'whisper-attack-bottom-left-9',
          'whisper-attack-bottom-left-10',
          'whisper-attack-bottom-left-11',
          'whisper-attack-bottom-left-12',
          'whisper-attack-bottom-left-13',
          'whisper-attack-bottom-left-14',
          'whisper-attack-bottom-left-15',
          'whisper-attack-bottom-left-16',
          'whisper-attack-bottom-left-17',
          'whisper-attack-bottom-left-18',
          'whisper-attack-bottom-left-19',
          'whisper-attack-bottom-left-20',
          'whisper-attack-bottom-left-21',
          'whisper-attack-bottom-left-22',
          'whisper-attack-bottom-left-23',
        ],
        'whisper-attack-left': [
          'whisper-attack-left-0',
          'whisper-attack-left-1',
          'whisper-attack-left-2',
          'whisper-attack-left-3',
          'whisper-attack-left-4',
          'whisper-attack-left-5',
          'whisper-attack-left-6',
          'whisper-attack-left-7',
          'whisper-attack-left-8',
          'whisper-attack-left-9',
          'whisper-attack-left-10',
          'whisper-attack-left-11',
          'whisper-attack-left-12',
          'whisper-attack-left-13',
          'whisper-attack-left-14',
          'whisper-attack-left-15',
          'whisper-attack-left-16',
          'whisper-attack-left-17',
          'whisper-attack-left-18',
          'whisper-attack-left-19',
          'whisper-attack-left-20',
          'whisper-attack-left-21',
          'whisper-attack-left-22',
          'whisper-attack-left-23',
        ],
        'whisper-attack-top-left': [
          'whisper-attack-top-left-0',
          'whisper-attack-top-left-1',
          'whisper-attack-top-left-2',
          'whisper-attack-top-left-3',
          'whisper-attack-top-left-4',
          'whisper-attack-top-left-5',
          'whisper-attack-top-left-6',
          'whisper-attack-top-left-7',
          'whisper-attack-top-left-8',
          'whisper-attack-top-left-9',
          'whisper-attack-top-left-10',
          'whisper-attack-top-left-11',
          'whisper-attack-top-left-12',
          'whisper-attack-top-left-13',
          'whisper-attack-top-left-14',
          'whisper-attack-top-left-15',
          'whisper-attack-top-left-16',
          'whisper-attack-top-left-17',
          'whisper-attack-top-left-18',
          'whisper-attack-top-left-19',
          'whisper-attack-top-left-20',
          'whisper-attack-top-left-21',
          'whisper-attack-top-left-22',
          'whisper-attack-top-left-23',
        ],
        'whisper-attack-top': [
          'whisper-attack-top-0',
          'whisper-attack-top-1',
          'whisper-attack-top-2',
          'whisper-attack-top-3',
          'whisper-attack-top-4',
          'whisper-attack-top-5',
          'whisper-attack-top-6',
          'whisper-attack-top-7',
          'whisper-attack-top-8',
          'whisper-attack-top-9',
          'whisper-attack-top-10',
          'whisper-attack-top-11',
          'whisper-attack-top-12',
          'whisper-attack-top-13',
          'whisper-attack-top-14',
          'whisper-attack-top-15',
          'whisper-attack-top-16',
          'whisper-attack-top-17',
          'whisper-attack-top-18',
          'whisper-attack-top-19',
          'whisper-attack-top-20',
          'whisper-attack-top-21',
          'whisper-attack-top-22',
          'whisper-attack-top-23',
        ],
      },
    },
  },
  {
    name: 'whisper-death',
    metadata: {
      frames: {
        'whisper-death-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-20': {
          frame: {
            x: 5120,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-21': {
          frame: {
            x: 5376,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-22': {
          frame: {
            x: 5632,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-death-bottom-23': {
          frame: {
            x: 5888,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/whisper/death.png',
        size: {
          w: 6144,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'whisper-death-bottom': [
          'whisper-death-bottom-0',
          'whisper-death-bottom-1',
          'whisper-death-bottom-2',
          'whisper-death-bottom-3',
          'whisper-death-bottom-4',
          'whisper-death-bottom-5',
          'whisper-death-bottom-6',
          'whisper-death-bottom-7',
          'whisper-death-bottom-8',
          'whisper-death-bottom-9',
          'whisper-death-bottom-10',
          'whisper-death-bottom-11',
          'whisper-death-bottom-12',
          'whisper-death-bottom-13',
          'whisper-death-bottom-14',
          'whisper-death-bottom-15',
          'whisper-death-bottom-16',
          'whisper-death-bottom-17',
          'whisper-death-bottom-18',
          'whisper-death-bottom-19',
          'whisper-death-bottom-20',
          'whisper-death-bottom-21',
          'whisper-death-bottom-22',
          'whisper-death-bottom-23',
        ],
        'whisper-death-bottom-left': [
          'whisper-death-bottom-0',
          'whisper-death-bottom-1',
          'whisper-death-bottom-2',
          'whisper-death-bottom-3',
          'whisper-death-bottom-4',
          'whisper-death-bottom-5',
          'whisper-death-bottom-6',
          'whisper-death-bottom-7',
          'whisper-death-bottom-8',
          'whisper-death-bottom-9',
          'whisper-death-bottom-10',
          'whisper-death-bottom-11',
          'whisper-death-bottom-12',
          'whisper-death-bottom-13',
          'whisper-death-bottom-14',
          'whisper-death-bottom-15',
          'whisper-death-bottom-16',
          'whisper-death-bottom-17',
          'whisper-death-bottom-18',
          'whisper-death-bottom-19',
          'whisper-death-bottom-20',
          'whisper-death-bottom-21',
          'whisper-death-bottom-22',
          'whisper-death-bottom-23',
        ],
        'whisper-death-left': [
          'whisper-death-bottom-0',
          'whisper-death-bottom-1',
          'whisper-death-bottom-2',
          'whisper-death-bottom-3',
          'whisper-death-bottom-4',
          'whisper-death-bottom-5',
          'whisper-death-bottom-6',
          'whisper-death-bottom-7',
          'whisper-death-bottom-8',
          'whisper-death-bottom-9',
          'whisper-death-bottom-10',
          'whisper-death-bottom-11',
          'whisper-death-bottom-12',
          'whisper-death-bottom-13',
          'whisper-death-bottom-14',
          'whisper-death-bottom-15',
          'whisper-death-bottom-16',
          'whisper-death-bottom-17',
          'whisper-death-bottom-18',
          'whisper-death-bottom-19',
          'whisper-death-bottom-20',
          'whisper-death-bottom-21',
          'whisper-death-bottom-22',
          'whisper-death-bottom-23',
        ],
        'whisper-death-top-left': [
          'whisper-death-bottom-0',
          'whisper-death-bottom-1',
          'whisper-death-bottom-2',
          'whisper-death-bottom-3',
          'whisper-death-bottom-4',
          'whisper-death-bottom-5',
          'whisper-death-bottom-6',
          'whisper-death-bottom-7',
          'whisper-death-bottom-8',
          'whisper-death-bottom-9',
          'whisper-death-bottom-10',
          'whisper-death-bottom-11',
          'whisper-death-bottom-12',
          'whisper-death-bottom-13',
          'whisper-death-bottom-14',
          'whisper-death-bottom-15',
          'whisper-death-bottom-16',
          'whisper-death-bottom-17',
          'whisper-death-bottom-18',
          'whisper-death-bottom-19',
          'whisper-death-bottom-20',
          'whisper-death-bottom-21',
          'whisper-death-bottom-22',
          'whisper-death-bottom-23',
        ],
        'whisper-death-top': [
          'whisper-death-bottom-0',
          'whisper-death-bottom-1',
          'whisper-death-bottom-2',
          'whisper-death-bottom-3',
          'whisper-death-bottom-4',
          'whisper-death-bottom-5',
          'whisper-death-bottom-6',
          'whisper-death-bottom-7',
          'whisper-death-bottom-8',
          'whisper-death-bottom-9',
          'whisper-death-bottom-10',
          'whisper-death-bottom-11',
          'whisper-death-bottom-12',
          'whisper-death-bottom-13',
          'whisper-death-bottom-14',
          'whisper-death-bottom-15',
          'whisper-death-bottom-16',
          'whisper-death-bottom-17',
          'whisper-death-bottom-18',
          'whisper-death-bottom-19',
          'whisper-death-bottom-20',
          'whisper-death-bottom-21',
          'whisper-death-bottom-22',
          'whisper-death-bottom-23',
        ],
      },
    },
  },
  {
    name: 'whisper-idle',
    metadata: {
      frames: {
        'whisper-idle-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'whisper-idle-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/whisper/idle.png',
        size: {
          w: 3072,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'whisper-idle-bottom': [
          'whisper-idle-bottom-0',
          'whisper-idle-bottom-1',
          'whisper-idle-bottom-2',
          'whisper-idle-bottom-3',
          'whisper-idle-bottom-4',
          'whisper-idle-bottom-5',
          'whisper-idle-bottom-6',
          'whisper-idle-bottom-7',
          'whisper-idle-bottom-8',
          'whisper-idle-bottom-9',
          'whisper-idle-bottom-10',
          'whisper-idle-bottom-11',
        ],
        'whisper-idle-bottom-left': [
          'whisper-idle-bottom-left-0',
          'whisper-idle-bottom-left-1',
          'whisper-idle-bottom-left-2',
          'whisper-idle-bottom-left-3',
          'whisper-idle-bottom-left-4',
          'whisper-idle-bottom-left-5',
          'whisper-idle-bottom-left-6',
          'whisper-idle-bottom-left-7',
          'whisper-idle-bottom-left-8',
          'whisper-idle-bottom-left-9',
          'whisper-idle-bottom-left-10',
          'whisper-idle-bottom-left-11',
        ],
        'whisper-idle-left': [
          'whisper-idle-left-0',
          'whisper-idle-left-1',
          'whisper-idle-left-2',
          'whisper-idle-left-3',
          'whisper-idle-left-4',
          'whisper-idle-left-5',
          'whisper-idle-left-6',
          'whisper-idle-left-7',
          'whisper-idle-left-8',
          'whisper-idle-left-9',
          'whisper-idle-left-10',
          'whisper-idle-left-11',
        ],
        'whisper-idle-top-left': [
          'whisper-idle-top-left-0',
          'whisper-idle-top-left-1',
          'whisper-idle-top-left-2',
          'whisper-idle-top-left-3',
          'whisper-idle-top-left-4',
          'whisper-idle-top-left-5',
          'whisper-idle-top-left-6',
          'whisper-idle-top-left-7',
          'whisper-idle-top-left-8',
          'whisper-idle-top-left-9',
          'whisper-idle-top-left-10',
          'whisper-idle-top-left-11',
        ],
        'whisper-idle-top': [
          'whisper-idle-top-0',
          'whisper-idle-top-1',
          'whisper-idle-top-2',
          'whisper-idle-top-3',
          'whisper-idle-top-4',
          'whisper-idle-top-5',
          'whisper-idle-top-6',
          'whisper-idle-top-7',
          'whisper-idle-top-8',
          'whisper-idle-top-9',
          'whisper-idle-top-10',
          'whisper-idle-top-11',
        ],
      },
    },
  },
];
